<template>
  <div>
    <div class="friend-hd">
      <van-search v-model="mesage" placeholder="搜索" class="fr-hd_inp" />
    </div>
    <div class="friend-list">
      <van-list
        v-model="vanListVisable"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-swipe-cell v-for="(item,index) in list" :key="index">
          <van-cell class="vanCell">
            <van-skeleton
              title
              avatar
              :row="3"
              :loading="loading"
            >
              <div class="sy-cell_between" @click="LinkUrl(item.accountId,item.name)">
                <div class="box">
                  <img class="headerUrl" :src="item.doctorCcertificate">
                  <!-- <div v-if="item.dot>0" class="dot">{{ item.dot>99?'···':item.dot }}</div> -->
                </div>
                <div class="content">
                  <div>{{ item.name }}</div>
                  <div class="text ellipsis">	职称：{{ item.professionalTitle }}</div>
                  <div class="text2 ellipsis">擅长：{{ item.skill?item.skill:'暂时未知' }}</div>
                </div>

              </div>
            </van-skeleton>
          </van-cell>
        </van-swipe-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import { fetchDoctor } from '@/api/chat'
import { getAccountId } from '@/utils/auth'
export default {
  name: 'Friend',
  data() {
    return {
      accountId: getAccountId(),
      mesage: '',
      loading: false, // 骨架屏开关，true是开
      vanListVisable: false,
      finished: true,
      list: [
        // {
        //   header: require('@/assets/images/doc/0.png'),
        //   name: '李海峰',
        //   dot: 1,
        //   gender: '主任医师 教授',
        //   goodAt: '擅长主治:灰指甲、甲沟炎、腋臭、皮炎、湿疹等'
        // },
        // {
        //   header: require('@/assets/images/doc/1.jpg'),
        //   name: '刘海波',
        //   gender: '主任医师 教授',
        //   dot: 100,
        //   goodAt: '冠心病的诊断及介入'
        // },
        // {
        //   header: require('@/assets/images/doc/2.png'),
        //   name: '朱国行',
        //   gender: '主任医师 教授',
        //   dot: 0,
        //   goodAt: '癫痫、头痛、睡眠障碍、脑炎（自身免疫性脑炎）、神经痛及脑血管病等神经内科疾病的诊治和脑电图的判读分析'
        // },
        // {
        //   header: require('@/assets/images/doc/3.jpg'),
        //   name: '邹丽萍',
        //   gender: '主任医师 教授',
        //   dot: 9,
        //   goodAt: '擅长儿童常见疾病，特别是疑难杂症的诊治等'
        // },
        // {
        //   header: require('@/assets/images/doc/4.jpg'),
        //   name: '张涛',
        //   gender: '副主任医师',
        //   dot: 0,
        //   goodAt: '腰椎间孔镜微创手术、椎体成型微创手术'
        // },
        // {
        //   header: require('@/assets/images/doc/5.jpg'),
        //   name: '皇甫小桥',
        //   gender: '主任医师 教授',
        //   dot: 9,
        //   goodAt: '关节镜下微创治疗肩、膝、髋、肘关节的运动损伤及其关节疾患'
        // }
      ]
    }
  },
  created() {
    this.getDoctor()
  },
  methods: {
    onLoad() {
      // 异步更新数据

    },
    LinkUrl(toId, toName) {
      if (this.$store.state.platform === 'android') { // 安卓
        console.log('安卓')
        window.Android.openConversation({ 'toAccount': toId, 'toUserInfo': { 'name': toName }})
        // window.jsObj.方法名2(参数);
      } else if (this.$store.state.platform === 'ios') {
        window.webkit.messageHandlers.openConversation.postMessage({ 'toAccount': toId, 'toUserInfo': { 'name': toName }})
      } else { // 吊起原生
        this.$router.push('/chat')
      }
    },
    getDoctor() {
      // console.log(123)
      fetchDoctor({
        accountId: this.accountId
      }).then(res => {
        this.list = res.data.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.friend-hd{
  width:100%;
  .fr-hd_inp{
    outline: none;
    width:352px;
    height:30px;
    background:rgba(255,255,255,1);
    border-radius:4px;
    margin:10px 12px 10px;
    border:none;
    .van-search__content{
      background:#fff;
      .van-cell{
        padding-top:0!important;
        padding-bottom:0!important;
      }
    }
  }
}
.friend-list{
  width: 100%;
  height: auto;
  .vanCell{
    height:auto;
    min-height:110px;
    background:rgba(255,255,255,1);
    padding:0px 13px;
    border-bottom:1px solid #f5f5f5;
    .sy-cell_between{
      height: 100%;
      .box{
      position: relative;

      }
    }
    .dot{
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #ED0600;
      position: absolute;
      top:-5px;
      left:35px;
      font-size: 12px;
      line-height: 18px;
      color:#fff;
      font-weight: bold;
      text-align: center;
      transform: scale(0.8);
    }
    .headerUrl{
      width:50px;
      height:50px;
      background:rgba(216,216,216,1);
      border-radius: 50%;
      margin-right:11px;
    }
    .content{
      flex:1;
      color:#333333;
      font-size: 16px;
      .text{
        color:#999;
        font-size: 12px;
        -webkit-line-clamp: 1;
      }
      .text2{
        color:#666;
        font-size: 14px;
      }
    }
    .time{
      color:#999;
      padding-left:11px;
    }
  }
  // .vanCell:last-child {
  //   border:none;
  // }
}
</style>

